import { useRef, useState } from "react";

export function useCoolDown(callback = (...args) => { }, timeout = 600, async = false) {

    const timer = useRef(null)

    const [pending, setPending] = useState(false)

    const modifiedCallback = (...args) => {
        if (timer.current)
            clearTimeout(timer.current)

        timer.current = setTimeout(async () => {
            setPending(true)
            const result = await callback(...args)
            setPending(false)
            return result
        }, timeout)
    }

    return async ? [modifiedCallback, pending] : modifiedCallback
}
